import React from 'react';
import { NavItem } from './types';
 
interface MobileBottomNavProps {
  darkMode: boolean;
  navItems: NavItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
 
export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  darkMode,
  navItems,
  activeTab,
  onTabChange,
}) => {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 border-t lg:hidden z-50 transition-colors"
      style={{
        background: darkMode ? 'rgba(13,26,26,0.97)' : 'rgba(240,250,250,0.97)',
        backdropFilter: 'blur(12px)',
        borderColor: darkMode ? 'rgba(90,184,184,0.15)' : 'rgba(13,26,26,0.1)',
      }}
    >
      <div className="flex justify-around items-center py-2 safe-area-bottom">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = item.id === activeTab;
          return (
            <button
              key={item.id}
              onClick={() => onTabChange(item.id)}
              className="flex flex-col items-center p-2 relative transition-colors min-w-[52px]"
              style={{ color: isActive ? '#e8a820' : darkMode ? 'rgba(126,206,206,0.4)' : 'rgba(13,26,26,0.45)' }}
            >
              {/* Active indicator dot */}
              {isActive && (
                <div
                  className="absolute top-0 left-1/2 -translate-x-1/2 rounded-full"
                  style={{ width: '24px', height: '3px', background: '#e8a820' }}
                />
              )}
              <Icon style={{ fontSize: '18px' }} />
              <span
                className="mt-1 font-bold"
                style={{ fontSize: '9px', letterSpacing: '0.5px' }}
              >
                {item.label.toUpperCase()}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};